
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

export const firebaseConfig = {
  apiKey: "AIzaSyBPvz13afYKRmNfJWksvWdYf3bxSy_sLz0",
  authDomain: "quantum-metrics-app.firebaseapp.com",
  projectId: "quantum-metrics-app",
  storageBucket: "quantum-metrics-app.appspot.com",
  messagingSenderId: "334319125789",
  appId: "1:334319125789:web:d69bed433d32ea5628cdf4"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
